const headerFunc = () => {
  // ハンバーガーメニュー
  $('.l-header__toggle').on('click', function () {
    $(this).toggleClass('is-active');
    $('.l-header__navigation').toggleClass('is-active');
  });

  $('.l-header__navigation a').on('click', function () {
    $('.l-header__toggle').removeClass('is-active');
    $('.l-header__navigation').removeClass('is-active');
  });
}

export default headerFunc;
